
export default {
    'ContentMaxWidt': 900,
    'Gutter': {
        Mobile: 15,
        Tablet: 15,
        Laptop: 15,
        Desktop: 15,
        BigDesktop: 15
    },
};


// WEBPACK FOOTER //
// ./src/constants/spacing.ts